export const drawOneShape = (mapHandle, oneShape, modificationWatcher) => {
  const DEFAULT_FILL = '#FF0000'
  const STROKE_OPACITY = 0.8
  const FILL_OPACITY = 0.35
  const STROKE_WEIGHT = 2

  const relayPolygonCoordsChange = currentPoly => {
    const allPolygonCoords = currentPoly.getPath()
    const coordsToSet = []

    for (let i = 0; i < allPolygonCoords.getLength(); i++) {
      const data = {
        lat: allPolygonCoords.getAt(i).lat(),
        lng: allPolygonCoords.getAt(i).lng()
      }
      data && coordsToSet.push(data)
    }

    const id = currentPoly.get('id')
    const type = currentPoly.get('type')
    const isNew = currentPoly.get('isNew')
    const name = currentPoly.get('name')

    modificationWatcher({
      type,
      id,
      name,
      isNew,
      coords: coordsToSet
    })
  }

  const editable = modificationWatcher ? true : false
  let oneDrawing = null
  switch (oneShape.type) {
    case 'circle': {
      const oneCircle = new window.google.maps.Circle({
        strokeColor: DEFAULT_FILL,
        strokeOpacity: STROKE_OPACITY,
        strokeWeight: STROKE_WEIGHT,
        fillColor: DEFAULT_FILL,
        fillOpacity: FILL_OPACITY,
        center: oneShape.center,
        radius: oneShape.radius,
        editable: editable,
        draggable: editable
      })
      oneCircle.addListener('bounds_changed', () => {
        modificationWatcher({
          type: oneShape.type,
          name: oneShape.name,
          id: oneCircle.get('id'),
          center: {
            lat: oneCircle.getCenter().lat(),
            lng: oneCircle.getCenter().lng()
          },
          radius: oneCircle.getRadius(),
          isNew: oneCircle.get('isNew')
        })
      })
      oneDrawing = oneCircle
      break
    }

    case 'rectangle': {
      const oneRectangle = new window.google.maps.Rectangle({
        strokeColor: DEFAULT_FILL,
        strokeOpacity: STROKE_OPACITY,
        strokeWeight: STROKE_WEIGHT,
        fillColor: DEFAULT_FILL,
        fillOpacity: FILL_OPACITY,
        bounds: {
          north: Number(oneShape.bounds.north),
          south: Number(oneShape.bounds.south),
          east: Number(oneShape.bounds.east),
          west: Number(oneShape.bounds.west)
        },
        editable: editable,
        draggable: editable
      })
      oneRectangle.addListener('bounds_changed', () => {
        modificationWatcher({
          type: oneShape.type,
          name: oneShape.name,
          id: oneRectangle.get('id'),
          bounds: {
            north: oneRectangle.getBounds().Ua.hi,
            west: oneRectangle.getBounds().Ha.lo,
            south: oneRectangle.getBounds().Ua.lo,
            east: oneRectangle.getBounds().Ha.hi
          },
          isNew: oneRectangle.get('isNew')
        })
      })
      oneDrawing = oneRectangle
      break
    }

    default: {
      // polygon
      const onePoly = new window.google.maps.Polygon({
        paths: oneShape.coords,
        strokeColor: DEFAULT_FILL,
        strokeOpacity: STROKE_OPACITY,
        strokeWeight: STROKE_WEIGHT,
        fillColor: DEFAULT_FILL,
        fillOpacity: FILL_OPACITY,
        draggable: editable,
        editable: editable
      })

      onePoly.getPaths().forEach(path => {
        window.google.maps.event.addListener(path, 'insert_at', () => {
          relayPolygonCoordsChange(onePoly, !oneShape.id)
        })
        window.google.maps.event.addListener(path, 'remove_at', () => {
          relayPolygonCoordsChange(onePoly, !oneShape.id)
        })
        window.google.maps.event.addListener(path, 'set_at', () => {
          relayPolygonCoordsChange(onePoly, !oneShape.id)
        })
      })

      oneDrawing = onePoly
      break
    }
  }

  oneDrawing.set('id', oneShape.id)
  oneDrawing.set('type', oneShape.type)
  oneDrawing.set('isNew', oneShape.isNew)
  oneDrawing.set('name', oneShape.name)
  oneDrawing.setVisible(true)
  oneDrawing.setMap(mapHandle)

  return oneDrawing
}

export const drawAllShapes = (mapHandle, shapeArray, modificationWatcher) => {
  shapeArray.forEach(oneShape => {
    drawOneShape(mapHandle, oneShape, modificationWatcher)
  })
}
